import React, { useEffect, useState } from "react";
import { CardElement, CardNumberElement, CardCvcElement, CardExpiryElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import axios from "axios";
import Loader from "../../UI/loader";
import { connect } from "react-redux";
import { setCardStatusPopupProps, cardValidation } from "../../action/autoCheckin";
import { popupOpenClose, setCheckInAddress } from "../../../action/action";
import {withTranslation} from 'react-i18next'
import countries from '../../JS/country-states.json'
import { sendAnalytics } from "../../../action/homeAction"
import clientConfigApi from '../../../config/config';

const Card = (props) => {
    const elements = useElements();
    const stripe = useStripe();
    const [response, setResponse] = useState(true);
    const [lastNameCard, setLastNameCard] = useState(props.lastName || "");
    const [firstNameCard, setFirstNameCard] = useState(props.firstName || "");
    const [paymentIdentifier, setPaymentIdentifier] = useState("");
    const [cardNumberComplete, setCardNumberComplete] = useState(false);
    const [cardExpiryComplete, setCardExpiryComplete] = useState(false);
    const [cardCVCComplete, setCardCVCComplete] = useState(false);
    const [cardNotVerifiedAtPMS, setCardNotVerifiedAtPMS] = useState(false)
    const [checkinSessionToken, setCheckinSessionToken] = useState(localStorage.getItem("checkinSessionToken"))
    const [address, setAddress] = useState({"addressLine1": "","addressLine2": "","city": "","state": "","postalCode": "","country": ""})
    
    const CARD_ELEMENT_OPTIONS = {
        style: {
          base: {
            color: props.menuColor.assetFontColor,
            fontFamily: 'Plain',
            fontSmoothing: "antialiased",
            fontSize: "15px",
            "::placeholder": {
              color: "#999",
            },
            borderBottom: "2px solid black"
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
          width: '100px'
        },
      };
      
    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!stripe || !elements){
            return;
        }

        if(!firstNameCard){
            props.popupOpenClose(true, "Please enter your first name");
            return;
        }
        if(!lastNameCard){
            props.popupOpenClose(true, "Please enter your last name");
            return;
        }
        if(!(cardCVCComplete && cardNumberComplete && cardExpiryComplete)){
            props.popupOpenClose(true, "Please enter all the required card fields correctly.");
            return;
        }
        let validAddress = address.country &&
                             address.addressLine1 &&
                              address.postalCode && address.city && 
                              address.country !== "select" && address.state !== "select"
        if(!validAddress){
            props.popupOpenClose(true, "Please fill all the required address fields");
            return;
        }
        const { country, state, ...updatedAddress } = address;
        props.setCheckInAddress({ ...props.checkInAddress, ...updatedAddress });
        try {
            props.setLoader(true)

            let clientSecret;

            if(cardNotVerifiedAtPMS){
                props.guestBookFormData.delete('confirmationNumber');
                props.guestBookFormData.append('confirmationNumber',props.confirmationNumber);
                await clientConfigApi.post(
                    "/mobileCheckIn/guestBooking",props.guestBookFormData)
                    .then((response)=> {
                        props.cardValidation("register", response.data.payload.confirmationNumber, (setupIntentSecret, error) => {
                            if(setupIntentSecret){
                                clientSecret = setupIntentSecret                                
                            } else {
                                props.showFailScreen(true, error.msg)
                                logAnalytics(false, error.msg)
                                props.setLoader(false)
                            }
                        })
                    })
                    .catch(error => {
                        props.setLoader(false)
                        let errorMessage;
                        if (error.response && error.response.data && error.response.data.header && error.response.status == 400){
                            props.showFailScreen(true, error.response.data.header.status.msg)
                            errorMessage = error.response.data.header.status.msg
                        } else {
                            props.showFailScreen(true, "Something went wrong")
                            errorMessage = "Something went wrong"
                        }
                            
                        logAnalytics(false, errorMessage)
                        props.goBack(true)
                    })
                } else {
                    await props.cardValidation("register", props.confirmationNumber, (setupIntentSecret, error) => {
                        console.log("card validation response", setupIntentSecret, error)
                        if(setupIntentSecret){
                            clientSecret = setupIntentSecret                                
                        } else {
                            props.showFailScreen(true, error.msg)
                            logAnalytics(false, error.msg)
                            props.setLoader(false)
                        }
                    }).then(res => console.log("response for the cardvalidation call"))
                }

                setTimeout(async () => {
                try{
                    let gotClientSecret = clientSecret
                    if(gotClientSecret){
                    const res = await stripe.confirmCardSetup(
                        clientSecret,
                        {
                            payment_method: {
                                card: elements.getElement(CardNumberElement, CardCvcElement, CardExpiryElement,),
                                billing_details: {
                                    address: {
                                        city: address.city,
                                        country: address.country,
                                        line1: address.addressLine1,
                                        line2: address.addressLine2,
                                        postal_code: address.postalCode,
                                        state: address.state,
                                    },
                                }
                            }
                        }
                    )
                    setResponse(res)
                    console.log('response.setupIntent',res)
                    if(!res.error){
                        // We dont send the card digits in the below api call, CMS makes another api call to stripe using setupIntent.payment_method (card id) to get the card digits
                        props.cardValidation("checks", props.confirmationNumber, callBack, lastNameCard, firstNameCard, res.setupIntent.payment_method )
                    } else {
                        // props.setError(true)
                        console.log("Error line 65")
                        props.setLoader(false)
                        props.showFailScreen(true, res.error.message)
                        logAnalytics(false, res.error.message)
                    }}
                } catch (error) {
                    props.setLoader(false)
                    props.showFailScreen(true, error.message)
                    logAnalytics(false, error.message)
                }
            }, 2500)

        } catch (e) {
            // props.setError(true)
            console.log("Error line 76", e)
            props.showFailScreen(true, e.message)
            props.setLoader(false)
            logAnalytics(false, e.message)
        }
    
      }

      const logAnalytics = (status, error) => {

        let label = {
            "dateTime": new Date,
            "errorMessage": !status ? error : "",
            "appVersion": `${props.installedAppVersion}(${props.installedAppBuildNo})`,
            "sourceApp": "guestJourneyApp"
        }

        props.sendAnalytics(
            null, 
            props.currentWidgetObj.widgetType || "Mobile Check-in", 
            status ? "CREDIT CARD DETAILS - SUCCESS" : "CREDIT CARD DETAILS - FAILED", 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "CREDIT CARD DETAILS", "widgetSessionId": checkinSessionToken}, 
            0, 
            false
        );
      }

      const callBack = (status, error) => {
          if(status){
            props.showCardVerified({firstName: firstNameCard, lastName: lastNameCard})
            localStorage.setItem('cardVerfied', true);
            props.setCardStatusPopupProps({
                cardStatus: true,
                statusTitle: 'Success',
                statusMessage1: 'Card verified successfully',
                statusMessage2: 'Please proceed to next steps'
            })
            props.setLoader(false)
            logAnalytics(true, "")
          } else {

            props.setLoader(false)
            if(error && error.errorType && error.errorType == 'CARDOBJECT'){
                props.showFailScreen(true, error.msg, true);
            } else {
                props.showFailScreen(true, error.msg, false);                
            }
            setCardNotVerifiedAtPMS(true)
            // props.setError(true)
            logAnalytics(false, error.msg)
          }
    }

    const addressHandler = (event) => {
        const updtAdd = {...address,
          [event.target.name]: event.target.value};
      
        setAddress(updtAdd);
      }

    const getStateList = (id,arr) => {

        let stateList = [];
        for (let obj of arr){
          if(id == obj.countryId){
            stateList = obj.stateList
          }
        }
        return stateList;
      }

    const cardElementsChanged = (elementType, event) => {
        console.log('event',event)
        if(elementType == 'number'){
            setCardNumberComplete(event.complete);
        } else if(elementType == 'expiry'){
            setCardExpiryComplete(event.complete);
        } else if(elementType == 'cvc'){
            setCardCVCComplete(event.complete);
        } 
        return;
    }

    React.useEffect(() => {
        setAddress(prevAddress => ({ ...prevAddress, ...props.checkInAddress, "country": "US", "state": "" }));
    },[])


    return (
        <>
            <form onSubmit={handleSubmit}>
                {/* <CardElement options={CARD_ELEMENT_OPTIONS} /> */}
                <div style={{display: 'flex'}} >
                    <div className="form-row margin-bottom-1 margin-right-1" style={{width: '50%'}} >
                        <label for="firstName">First Name</label>
                        <input 
                            name="firstName"
                            autoComplete="given-name" 
                            onChange={(e) => setFirstNameCard(e.target.value)} 
                            value={firstNameCard}
                            type="text" 
                            placeholder="First Name" />
                    </div>
                    <div className="form-row margin-bottom-1 margin-right-1" style={{width: '50%'}} >
                        <label for="lastName">Last Name</label>
                        <input 
                            name="lastName"
                            autoComplete="family-name" 
                            onChange={(e) => setLastNameCard(e.target.value)} 
                            value={lastNameCard}
                            type="text" 
                            placeholder="Last Name" />
                    </div>
                </div>
                <div className="form-row margin-bottom-1 margin-right-1">
                    <label for="card-no">Card Number</label>
                    <CardNumberElement onChange={(e) => cardElementsChanged('number', e)} options={CARD_ELEMENT_OPTIONS} className="stripe-element" />
                </div>
                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}} >
                    <div className="form-row margin-bottom-1 margin-right-1">
                        <label for="cvv">Expiry</label>
                        <CardExpiryElement onChange={(e) => cardElementsChanged('expiry', e)} options={CARD_ELEMENT_OPTIONS} className="stripe-element" />
                    </div>
                    <div className="form-row margin-bottom-1 margin-right-1">
                        <label for="cvv">CVC</label>
                        <CardCvcElement onChange={(e) => cardElementsChanged('cvc', e)} options={CARD_ELEMENT_OPTIONS} className="stripe-element" />
                    </div>
                </div>
                <div className="form-row margin-bottom-1 booking2_address_cont">
                    <label>Address</label>
                    <div className="form-row margin-bottom-1 margin-right-1">
                        <input type="text" name="addressLine1" value = {address.addressLine1} autoComplete="address-line1" onChange = {(e) => addressHandler(e)}  placeholder={props.t('check_in.street_name_no')}/>
                    </div>
                    <div className="form-row margin-bottom-1 margin-right-1">
                        <input type="text" name="addressLine2" value = {address.addressLine2} autoComplete="address-line2" onChange = {(e) => addressHandler(e)} placeholder={props.t('check_in.bldg/unit/room')}/>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}} >
                        <div className="form-row margin-bottom-1 margin-right-1">
                            <select name="country" onChange={(e) => addressHandler(e)} >
                                <option value='select'>--select country--</option>
                                {
                                    Object.keys(countries.country).map(key => 
                                        <option value={key} selected={key == 'US'}>{countries.country[key]}</option>
                                    )
                                }
                            </select>
                        </div>
                        <div className="form-row margin-bottom-1 margin-right-1">
                            <select name="state" onChange={(e) => addressHandler(e)} >
                                <option value='select'>--select state--</option>
                                {
                                    countries.states[!isNaN(address.country) ? "US" : address.country] && countries.states[!isNaN(address.country) ? "US" : address.country].map(state => 
                                        <option value={state.name}>{state.name}</option>
                                    )
                                }
                            </select>
                        </div>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}} >
                        <div className="form-row margin-bottom-1 margin-right-1">
                            <input type="text" name="city" value = {address.city} autoComplete="address-level2" onChange = {(e) => addressHandler(e)} placeholder={props.t('check_in.city')}/>
                        </div>
                        <div className="form-row margin-bottom-1 margin-right-1">
                            <input name="postalCode" autoComplete="postal-code" value = {address.postalCode} onChange = {(e) => addressHandler(e)} placeholder={props.t('check_in.postal_code')}/>                            
                        </div>
                    </div>
                    
                    {/* <select name="country" value = {address.country} 
                    onChange = {(e) => addressHandler(e)} placeholder={props.t('check_in.country')}>
                        {
                        props.countryOptions.length > 0 ?
                        
                        props.countryOptions.map((el,index) => (
                            <option value={el.countryId}>{el.countryName}</option>
                        )) :
                        
                        <option value="">{props.t('check_in.select_country')}</option>

                        }
                    </select> */}
                    {/* <input type="text" name="country" value = {address.country} onChange = {(e) => this.addressHandler(e)} placeholder="Country"/> */}
                    {/* <select name="state" onChange = {(e) => addressHandler(e)} placeholder={props.t('check_in.state')}
                    value = {address.state}>
                        {
                        props.countryOptions.length > 0 ?
                        getStateList(address.country,props.countryOptions).map((el,index) => (
                            <option key = {el.stateId} value={el.stateId}>{el.stateName}</option>
                        )) : <option value="">{props.t('check_in.select_state')}</option>
                        }
    
                    </select> */}
                    </div>
                <ul style={{color: 'rgb(0,0,0,0.5)', padding: '0rem 1rem'}} >
                    <li><small>Use same card as provided while booking.</small></li>
                    <li><small>Your card is being verified at this stage, not charged.</small></li>
                </ul>
                <input disabled={props.cardverified} type="submit" value="Submit" style={{marginTop: '1rem', opacity: props.cardverified && '0.5'}}/>
            </form>
            {props.canSkipCardValidation && <input class="card-skip" onClick={() => props.next({firstName: firstNameCard, lastName: lastNameCard})} type="submit" value="Skip" style={{marginTop: '1rem', color: "#000", backgroundColor: "#fff"}}/>}
        </>
    );
}

const mapStateToProps = state => {
    return{
        showLoaderForCheckin: state.store2.showLoaderForCheckin,
        showSuccessErrorPopupForCheckin: state.store2.showSuccessErrorPopupForCheckin,
        cardStatus: state.store2.checkinCard.cardStatus,
        statusTitle: state.store2.checkinCard.statusTitle,
        statusMessage1: state.store2.checkinCard.statusMessage1,
        statusMessage2: state.store2.checkinCard.statusMessage2,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        menuColor: state.store.home.MenuColor,
        checkInAddress : state.store2.checkInAddress
    }
}



export default connect(mapStateToProps ,{
    setCardStatusPopupProps,
    cardValidation,
    popupOpenClose,
    setCheckInAddress,
    sendAnalytics
})(withTranslation('translations')(Card));